import { ArgsType, Int, Field } from '@nestjs/graphql'

@ArgsType()
export class GetCancellationsArgs {
  /** One reason or category; -1 or nothing for all of them. */
  @Field(t => Int, { nullable: true })
  cancelReason?: number

  /** Reasons or categories to leave out when `cancelReason` asks for all of them. [sc-28213] */
  @Field(t => [Int], { nullable: true })
  excludedReasons?: number[]

  @Field({ nullable: true })
  fromDate?: Date

  @Field({ nullable: true })
  toDate?: Date

  @Field({ nullable: true })
  groupByMonth?: boolean

  @Field(t => Int, { nullable: true })
  skip?: number

  @Field(t => Int, { nullable: true })
  take?: number
}
